import SalesMenuTypeForm from './SalesMenuTypeForm';

export default SalesMenuTypeForm;
